import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Radiobox Blank"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-radiobox-blank',
    templateUrl: './icon-radiobox-blank.component.html',
    styleUrls: ['./icon-radiobox-blank.component.scss'],
    standalone: false
})
export class IconRadioboxBlankComponent  {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
